enum EmpireName {
  AztecEmpire = 'AztecEmpire',
  FederationOfAsia = 'FederationOfAsia',
  NoramStates = 'NoramStates',
  PanafricanUnion = 'PanafricanUnion',
  RepublicOfEurope = 'RepublicOfEurope'
}

export default EmpireName